export enum NotesViewType {
  Payments = 'Payments',
  BackOffice = 'BackOffice',
}

export const isNoteTypePayments = (viewType: NotesViewType): boolean => {
  return viewType === NotesViewType.Payments
}

export const isNoteTypeBackOffice = (viewType: NotesViewType): boolean => {
  return viewType === NotesViewType.BackOffice
}

export const getNoteViewType = (type?: string): NotesViewType => {
  switch (type) {
    case NotesViewType.BackOffice:
      return NotesViewType.BackOffice
    case NotesViewType.Payments:
      return NotesViewType.Payments
    default:
      return NotesViewType.BackOffice
  }
}
